(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('PatientResultMissingDataSearch', PatientResultMissingDataSearch);

    PatientResultMissingDataSearch.$inject = ['$resource'];

    function PatientResultMissingDataSearch($resource) {
        var resourceUrl =  'api/_search/patient-result-missing-data/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
